module.exports = __webpack_public_path__ + "resources/img/img_codesign1.67d968d89f73b8dabcfd5e2df33d22b2.png";